import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TeamMgt } from './teammgt';
import { environment } from '../../environments/environment';
let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');
@Injectable({
  providedIn: 'root'
})

export class TeamMgtService {
  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;
  requestmapped: string;
  GetMenu(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/TeamMgtApi/GetMenuList/');
  }
  Getbyinfo(team: TeamMgt): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/TeamMgtApi/GetById', team, { headers: header, observe: 'response' });
  }

  Get(): Observable<TeamMgt[]> {
    return this.httpClient.get<TeamMgt[]>(this.baseUrl + 'api/TeamMgtApi')
  }
  Post(team: TeamMgt): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/TeamMgtApi/Add', team, { headers: header, observe: 'response' })
  }
  Delete(team: TeamMgt) {
    return this.httpClient.post<any>(this.baseUrl + 'api/TeamMgtApi/activeordeactive', team, { headers: header, observe: 'response' })
  }
  Put(team: TeamMgt): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/TeamMgtApi/Update', team, { headers: header, observe: 'response' })
  }
  GetAction()
    : Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/TeamMgtApi/GetActionList/');
  }
  GetRequestType()
    : Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/TeamMgtApi/GetRequestTypeList/');
  }
  UpdateTeamWithAllUser(team: TeamMgt): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/TeamMgtApi/UpdateTeamWithAllUser', team, { headers: header, observe: 'response' })
  }
}
